import { Component } from '@angular/core';
import { GlobalService } from '../../Services/global.service';
declare var $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  versionInfo: any = null;

  constructor(private service: GlobalService) {
    this.service.getVersionInfo().subscribe((info: any) => {
      this.versionInfo = info;
    });
  }

  scrollTop() {
    window.scroll(0,0)
  }
}
